import { Link } from 'react-router-dom';

export default function HeroSection() {
  const heroBgUrl = 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20flat%20lay%20product%20photography%20with%20carefully%20arranged%20modern%20lifestyle%20accessories%20including%20a%20minimal%20watch%20leather%20wallet%20notebook%20and%20small%20ceramic%20vase%20on%20warm%20cream%20linen%20textured%20surface%2C%20soft%20natural%20daylight%20from%20large%20window%2C%20editorial%20composition%2C%20gentle%20shadows%2C%20warm%20neutral%20beige%20and%20cream%20color%20palette%2C%20scandinavian%20organic%20modern%20aesthetic%2C%20high%20quality%20product%20styling%20with%20natural%20wood%20elements%20and%20dried%20botanical%20accents&width=1800&height=1200&seq=itaobuy-hero-v2-2026&orientation=landscape';

  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src={heroBgUrl}
        alt="Itaobuy lifestyle product scene with warm neutral tones"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight max-w-4xl mx-auto drop-shadow-sm">
          Itaobuy Spreadsheet
          <span className="block text-2xl md:text-4xl lg:text-5xl font-light mt-3 md:mt-4 font-sans opacity-90">
            The Smart Way to Organize, Track and Scale Your Buying Process
          </span>
        </h1>

        <p className="mt-6 md:mt-8 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          A powerful spreadsheet-based system designed to help users manage, analyze, and optimize their purchasing workflow with speed, clarity, and efficiency.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            itaobuy sheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            buy it now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
          <a
            href="#seo-articles"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm md:text-base hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Read Guides
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}